'use strict'

var _popin   = document.getElementById('md-search-popin');
var _input   = document.getElementById('SearchInPopin');
var _results = document.getElementById('search-popin-results');
var _debounce = null;

function openSearchPopin() {
    if (!_popin) return;
    _popin.style.display = 'flex';
    setTimeout(function () { _popin.classList.add('active'); }, 10);
    if (_input) setTimeout(function () { _input.focus(); }, 60);
}

function closeSearchPopin() {
    if (!_popin) return;
    _popin.classList.remove('active');
    setTimeout(function () {
        _popin.style.display = 'none';
        if (_input) _input.value = '';
        if (_results) _results.innerHTML = '';
    }, 280);
}

document.querySelectorAll('.search-popin__close').forEach(function (btn) {
    btn.addEventListener('click', closeSearchPopin);
});

// Fermeture en cliquant sur l'overlay (fond semi-transparent)
if (_popin) {
    _popin.addEventListener('click', function (e) {
        if (e.target === _popin) closeSearchPopin();
    });
}

// Bouton déclencheur (sur-header)
var _searchBtn = document.getElementById('search-btn');
if (_searchBtn) _searchBtn.addEventListener('click', openSearchPopin);

function formatPrice(amount) {
    return Number(amount).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }) + '\u00a0\u20ac';
}

function renderResults(products, query) {
    if (!_results) return;
    if (!products || products.length === 0) {
        _results.innerHTML = '<p class="search-results__msg">Aucun résultat pour « ' + query + ' ».</p>';
        return;
    }
    var html = '<span class="search-results__label">Produits</span><ul class="search-results__list">';
    products.forEach(function (p) {
        var img = '';
        if (p.featured_image && p.featured_image.url) {
            var src = p.featured_image.url;
            src = src.indexOf('?') !== -1 ? src + '&width=100' : src + '?width=100';
            img = '<img class="search-result-item__img" src="' + src + '" alt="' + (p.featured_image.alt || p.title) + '" width="52" height="52" loading="lazy">';
        } else {
            img = '<div class="search-result-item__placeholder"><i class="fa-solid fa-shirt" style="color:#ccc;font-size:1.5rem"></i></div>';
        }
        var price = '';
        if (p.price) {
            if (p.compare_at_price && p.compare_at_price > p.price) {
                price += '<span class="search-result-item__compare">' + formatPrice(p.compare_at_price) + '</span>';
            }
            price += formatPrice(p.price);
        }
        html += '<li><a href="' + p.url + '" class="search-result-item">'
            + img
            + '<div class="search-result-item__info">'
            + '<div class="search-result-item__title">' + p.title + '</div>'
            + (price ? '<div class="search-result-item__price">' + price + '</div>' : '')
            + '</div>'
            + '</a></li>';
    });
    html += '</ul>';
    html += '<a href="/search?q=' + encodeURIComponent(query) + '&options[prefix]=last&type=product" class="search-results__all">Voir tous les résultats</a>';
    _results.innerHTML = html;
}

function fetchResults(query) {
    if (!_results) return;
    _results.innerHTML = '<p class="search-results__msg">Recherche...</p>';
    fetch('/search/suggest?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6',
        { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(products, query);
        })
        .catch(function () {
            if (_results) _results.innerHTML = '<p class="search-results__msg">Erreur lors de la recherche.</p>';
        });
}

if (_input) {
    _input.addEventListener('input', function () {
        clearTimeout(_debounce);
        var q = _input.value.trim();
        if (q.length < 2) { if (_results) _results.innerHTML = ''; return; }
        _debounce = setTimeout(function () { fetchResults(q); }, 280);
    });
}
